import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetBuildings_buildingIdSubmeters = z.any()
export type TagsGetBuildings_buildingIdSubmeters = z.infer<typeof tagsGetBuildings_buildingIdSubmeters>

export const paramsGetBuildings_buildingIdSubmeters = z.object({ "buildingId": z.string().uuid() })
export type ParamsGetBuildings_buildingIdSubmeters = z.infer<typeof paramsGetBuildings_buildingIdSubmeters>

export const responseGetBuildings_buildingIdSubmeters = z.object({ "payload": z.array(z.object({ "id": z.string().uuid(), "collectionPointId": z.string().uuid(), "parentSubmeterId": z.union([z.string().uuid(), z.null()]), "name": z.string(), "meterCodes": z.union([z.array(z.string()), z.null()]).optional(), "note": z.union([z.string(), z.null()]).optional(), "electricityRegisterMode": z.union([z.enum(["single","dual"]), z.null()]).optional(), "consumptionReminderEnabled": z.boolean(), "consumptionReminderStartDate": z.union([z.string().date(), z.null()]).optional(), "consumptionReminderFrequency": z.enum(["weekly","monthly","yearly"]), "order": z.number(), "createdAt": z.string().optional(), "updatedAt": z.string().optional() })).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetBuildings_buildingIdSubmeters = z.infer<typeof responseGetBuildings_buildingIdSubmeters>

interface IGetBuildings_buildingIdSubmeters extends BaseMethodType {
  tags: TagsGetBuildings_buildingIdSubmeters,
  params: ParamsGetBuildings_buildingIdSubmeters,
  response: ResponseGetBuildings_buildingIdSubmeters
}
export const URL = '/buildings/:buildingId/submeters'
export const validation = {
  get: {
    tags: tagsGetBuildings_buildingIdSubmeters,
    params: paramsGetBuildings_buildingIdSubmeters,
    response: responseGetBuildings_buildingIdSubmeters
  }
}
export interface Buildings_buildingIdSubmeters extends BaseRouteType {
  get: IGetBuildings_buildingIdSubmeters
}